<!-- =========================================================================================
  File Name: AppEdit.vue
  Description: User Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-app-edit">
    <!-- Alert: No item found -->
    <b-alert
      variant="danger"
      :show="app_not_found"
    >
      <h4 class="alert-heading">
        {{ $t('apps.errorFetchingUserData') }}
      </h4>
      <i18n
        path="apps.notFound"
        tag="div"
        class="alert-body"
      >
        <span slot="hash">{{ $route.params.appHash }}</span>
        <b-link
          slot="link"
          class="alert-link"
          :to="{ name: 'apps' }"
        >
          {{ $t('apps.allApps') }}
        </b-link>
      </i18n>
    </b-alert>
    <AppEditIntegrationWizard
      :app-data="app_data"
      :on-active="activeTab === 0"
    />
    <b-card no-body>
      <b-tabs
        v-if="app_data !== null"
        v-model="activeTab"
        pills
        style="position: relative;"
        class="custom-tabs"
      >
        <!-- Tab: Account -->
        <b-tab active>
          <template #title>
            <feather-icon
              icon="CpuIcon"
              size="16"
              class="mr-0 mr-sm-50"
            />
            <span class="d-none d-sm-inline">{{ $t('apps.integration') }}</span>
          </template>
          <app-edit-integration
            ref="AppEditIntegration"
            v-model="app_data"
            :i-frame-url-query="iFrameURLQuery"
          />
        </b-tab>
        <!-- Tab: Information -->
        <b-tab>
          <template #title>
            <feather-icon
              icon="InfoIcon"
              size="16"
              class="mr-0 mr-sm-50"
            />
            <span class="d-none d-sm-inline">{{ $t('apps.general') }}</span>
          </template>
          <app-edit-general
            ref="AppEditGeneral"
            v-model="app_data"
            @reset="resetData($event)"
            @request-live="updateStatus($event)"
          />
        </b-tab>
        <!-- Tab: Social -->
        <b-tab>
          <template #title>
            <feather-icon
              icon="AwardIcon"
              size="16"
              class="mr-0 mr-sm-50"
            />
            <span class="d-none d-sm-inline">{{ $t('apps.rewards') }}</span>
            <b-badge
              v-if="!haveSetupOnTabReward"
              v-b-tooltip.hover.bottom
              variant="danger"
              class="tab-title-badge"
              :title="$t('apps.pleaseCompleteRewardsSettings')"
            >&nbsp;
            </b-badge>
          </template>
          <app-edit-rewards
            ref="AppEditRewards"
            v-model="app_data"
            :i-frame-url-query="iFrameURLQuery"
            @reset="resetData($event)"
          />
        </b-tab>
        <b-tab>
          <template #title>
            <feather-icon
              icon="CornerDownLeftIcon"
              size="16"
              class="mr-0 mr-sm-50"
            />
            <span class="d-none d-sm-inline">{{ $t('apps.redirects') }}</span>
          </template>
          <app-edit-redirects
            ref="AppEditRedirects"
            v-model="app_data"
            @reset="resetData($event)"
          />
        </b-tab>
        <!-- Tab: Social -->
        <b-tab>
          <template #title>
            <feather-icon
              icon="CornerDownLeftIcon"
              size="16"
              class="mr-0 mr-sm-50"
            />
            <span class="d-none d-sm-inline">{{ $t('apps.postback') }}</span>
            <b-badge
              v-if="!haveSetupOnTabPostback"
              v-b-tooltip.hover.bottom
              variant="danger"
              class="tab-title-badge"
              :title="$t('apps.pleaseSetUpAtLeastOnePostbackUrl')"
            >&nbsp;
            </b-badge>
          </template>
          <app-edit-postback
            ref="AppEditPostBack"
            v-model="app_data"
            @reset="resetData($event)"
          />
        </b-tab>
        <!-- Tab: Social -->
        <b-tab>
          <template
            #title
            class="tab-title"
          >
            <feather-icon
              icon="ImageIcon"
              size="16"
              class="mr-0 mr-sm-50"
            />
            <span class="d-none d-sm-inline">{{ $t('apps.design') }}</span>
          </template>
          <app-edit-design
            ref="AppEditDesign"
            v-model="app_data"
            @reset="resetData($event)"
            @iFrameURLQueryChanged="iFrameURLQuery = $event"
          />
        </b-tab>

        <template #tabs-end>
          <li style="position: absolute; right: 1.5rem;">
            <span
              v-if="haveUnsavedChanges"
              style="margin-right: 1rem; font-size: small; color: var(--warning);"
            >{{ $t('apps.youHaveUnsavedChanges') }}</span>
            <b-button
              variant="primary"
              @click="saveAllChanges()"
            >{{ $t('apps.saveChanges') }}
            </b-button>
            <!--                <b-button
                                variant="outline-secondary"
                                @click="resetAllChanges()"
                              >Reset all</b-button>-->
          </li>
        </template>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import i18n from '@/libs/i18n'

import AppEditIntegration from '@ps_views/apps/edit/AppEditIntegration.vue'
import AppEditIntegrationWizard from '@ps_views/apps/edit/AppEditIntegrationWizard.vue'
import AppEditGeneral from '@ps_views/apps/edit/AppEditGeneral.vue'
import AppEditRewards from '@ps_views/apps/edit/AppEditRewards.vue'
import AppEditPostback from '@ps_views/apps/edit/AppEditPostback.vue'
import AppEditDesign from '@ps_views/apps/edit/AppEditDesign.vue'
import AppEditRedirects from '@ps_views/apps/edit/AppEditRedirects.vue'

export default {
  components: {
    AppEditIntegration,
    AppEditIntegrationWizard,
    AppEditGeneral,
    AppEditRewards,
    AppEditPostback,
    AppEditDesign,
    AppEditRedirects,
    // CustomVsTab
  },
  data() {
    return {
      app_data: null,
      app_org_data: null,
      app_not_found: false,
      activeTab: 0,
      iFrameURLQuery: '',
    }
  },
  computed: {
    haveUnsavedChanges() {
      if (!this.app_org_data || !this.app_data) {
        return false
      }

      // Exclude is_games_offers_enabled from comparison as it has its own save endpoint
      const orgDataCopy = JSON.parse(JSON.stringify(this.app_org_data))
      const appDataCopy = JSON.parse(JSON.stringify(this.app_data))
      delete orgDataCopy.is_games_offers_enabled
      delete appDataCopy.is_games_offers_enabled

      // Normalize null, undefined, and empty string values to avoid false positives
      const normalizeValue = val => (val === null || val === '' || val === undefined ? null : val)

      // Get all unique keys from both objects
      const allKeys = new Set([...Object.keys(orgDataCopy), ...Object.keys(appDataCopy)])

      allKeys.forEach(key => {
        orgDataCopy[key] = normalizeValue(orgDataCopy[key])
        appDataCopy[key] = normalizeValue(appDataCopy[key])
      })

      return JSON.stringify(orgDataCopy) !== JSON.stringify(appDataCopy)
    },
    haveSetupOnTabReward() {
      return !!(this.app_data.currency_exchange_rate && this.app_data.currency_exchange_rate_screenouts && this.app_data.currency_name)
    },
    haveSetupOnTabPostback() {
      return !!(
        (this.app_data.postback_url && this.isValidHttpUrl(this.app_data.postback_url))
        || (this.app_data.offer_postback_url && this.isValidHttpUrl(this.app_data.offer_postback_url))
      )
    },
  },
  watch: {
    activeTab() {
      // this.fetch_user_data(this.$route.params.userId)
    },
  },
  created() {
    const { appHash } = this.$route.params
    this.$http.get(`/api/apps/get/${appHash}`).then(response => {
      const appData = response.data.app
      appData.admin_ips = Array.isArray(appData.admin_ips) ? appData.admin_ips : []
      this.app_data = appData
      this.app_org_data = JSON.parse(
        JSON.stringify(appData),
      )
      this.hideLoading()
    }).catch(() => {
      this.app_not_found = true
      this.hideLoading()
    })
  },
  mounted() {
    window.AppEdit = this
  },
  methods: {
    isValidHttpUrl(string) {
      let url

      try {
        url = new URL(string)
      } catch (_) {
        return false
      }

      return url.protocol === 'http:' || url.protocol === 'https:'
    },
    saveAllChanges() {
      this.showLoading();

      (async () => {
        const results = await Promise.all(this.validateAll())
        const activeIndex = this.activeTab
        let hasError = false

        const customTestModeError = !this.$refs.AppEditGeneral.validateTestModeValue()
        const customWhitelistedIpsError = !this.$refs.AppEditIntegration.validateWhitelistedIps()
        const customFontsError = !this.$refs.AppEditDesign.validateCustomFonts()

        if (!results[activeIndex]) {
          // Current tab has an error, keep it active
          hasError = true
        } else {
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < results.length; i++) {
            if (!results[i]) {
              this.activeTab = i
              hasError = true
              break
            }
          }
        }

        if (customWhitelistedIpsError) {
          this.activeTab = 0 // AppEditIntegration tab index
          hasError = true
        }

        if (customTestModeError) {
          this.activeTab = 1 // AppEditGeneral tab index
          hasError = true
        }

        if (customFontsError) {
          this.activeTab = 5 // AppEditDesign tab index
          hasError = true
        }

        if (hasError) {
          this.hideLoading()
        } else {
          this.sendRequestToApi()
        }
      })()
    },
    sendRequestToApi() {
      this.$http.post(
        `/api/apps/update/${this.app_data.hash}`,
        this.getFormData(),
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      ).then(response => {
        this.alertSuccess(response.data.message)
        const appData = response.data.app
        appData.admin_ips = Array.isArray(appData.admin_ips) ? appData.admin_ips : []
        this.app_data = appData
        this.app_org_data = JSON.parse(
          JSON.stringify(appData),
        )
      }).catch(errors => {
        this.alertApiError(errors, i18n.t('apps.appUpdateFailed'))
      }).finally(() => {
        this.hideLoading()
      })
    },
    getFormData() {
      this.showLoading()
      const formData = new FormData()

      this.app_data.test_mode_value = Array.isArray(this.app_data.test_mode_value)
        ? this.app_data.test_mode_value.filter(
          item => item?.type?.trim() && item?.value?.trim(),
        )
        : []

      if (Array.isArray(this.app_data.admin_ips)) {
        const normalizedIps = []
        const seenIps = new Set()

        this.app_data.admin_ips
          .map(ip => (typeof ip === 'string' ? ip.trim() : ''))
          .filter(ip => ip)
          .forEach(ip => {
            const key = ip.toLowerCase()
            if (seenIps.has(key)) {
              return
            }

            seenIps.add(key)
            normalizedIps.push(ip)
          })

        this.app_data.admin_ips = normalizedIps
      } else {
        this.app_data.admin_ips = []
      }

      Object.entries(this.app_data).forEach(([key, value]) => {
        if (key === 'design_config') {
          return
        }

        if (key === 'test_mode_value') {
          const safeValue = Array.isArray(value) ? value : []
          formData.append(key, JSON.stringify(safeValue))
        } else if (key === 'admin_ips') {
          const safeValue = Array.isArray(value) ? value : []
          formData.append(key, JSON.stringify(safeValue))
        } else if (key === 'test_mode') {
          formData.append(key, value ? 'true' : 'false') // Send string 'true' or 'false'
        } else if (typeof value === 'boolean') {
          formData.append(key, value ? 1 : 0)
        } else {
          formData.append(key, value === null ? '' : value)
        }
      })

      return formData
    },
    validateAll() {
      const tabNames = ['AppEditIntegration', 'AppEditGeneral', 'AppEditRewards', 'AppEditRedirects', 'AppEditPostBack', 'AppEditDesign']

      return tabNames.map(tabName => (
        this.$refs[tabName] && this.$refs[tabName].$refs && this.$refs[tabName].$refs.main_form
          ? this.$refs[tabName].$refs.main_form.validate()
          : Promise.resolve(true)
      ))
    },
    resetAllChanges() {
      this.app_data = JSON.parse(JSON.stringify(this.app_org_data))
    },
    resetData(listProperties) {
      listProperties.forEach(key => {
        this.app_data[key] = this.app_org_data[key]
      })
    },
    updateStatus(newStatus) {
      this.app_data.status = newStatus
      this.app_org_data.status = newStatus
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style>
#page-app-edit .custom-tabs > div {
  padding: 1.5rem;
  border-bottom: 1px solid #d8d8d8;
}

#page-app-edit .custom-tabs > div > ul {
  margin-bottom: 0px !important;
}

#page-app-edit .custom-tabs .tab-content {
  padding: 1.5rem;
}

.tab-title-badge {
  position: absolute;
  top: -0.5rem;
  right: -0.5rem;
  width: 14px;
  height: 14px;
  overflow: hidden;
  border-radius: 1rem;
  opacity: 0.5;
}

.tabs.custom-tabs .nav .nav-item {
  position: relative;
  border: 1px solid #ddd;
  margin: 0 1rem;
  border-radius: 0.5rem;
}
</style>
